import { render, staticRenderFns } from "./DkttHistory.vue?vue&type=template&id=669cac7a&scoped=true&"
import script from "./DkttHistory.vue?vue&type=script&lang=js&"
export * from "./DkttHistory.vue?vue&type=script&lang=js&"
import style0 from "./DkttHistory.vue?vue&type=style&index=0&id=669cac7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669cac7a",
  null
  
)

export default component.exports